<div class="desktop">
    <div class="label">
        {{label}}
    </div>
    <div class="text">
        <mat-select
        no-space 
        [tabindex]="i+2" 
        [value]="inputValue" 
        (selectionChange)="emit($event.value)">
            <input placeholder="Text" (blur)="emit($event.target.value)" matInput aria-label="field-text">
            <mat-option *ngFor="let option of options" [value]='option.value'>{{option.label}}</mat-option>
        </mat-select>
    </div>
</div>

<div class="mobile">
    <mat-form-field appearance="outline" (click)="openSelectDialog(label, inputValue, options)">
        <input matInput [placeholder]="label" [value]="inputValue">
        <mat-icon matSuffix>arrow_drop_down</mat-icon>
    </mat-form-field>
</div>